import {AdminAxios, MediaAxios} from "../../common/Axios";

const isInit = false;

/**
 * 일자별/시간대별 보고서 공통 조회 조건
 *
 * 화면에서는 다중 선택값을 react-select 호환을 위해 inventoryId에
 * 쉼표 구분 문자열로 보관하지만 API에는 명시적인 배열로 전달한다.
 * inventoryIds가 빈 배열이면 전체 지면을 의미한다.
 */
const toPeriodRequestParams = params => {
  const inventoryIds = Array.isArray(params?.inventoryIds)
      ? params.inventoryIds
      : params?.inventoryId
          ? String(params.inventoryId).split(',').filter(Boolean)
          : [];
  const requestParams = {...params, inventoryIds};
  delete requestParams.inventoryId;
  return requestParams;
};

// 매체 유저
export async function selectUserStaticsAll(userId, params) {
  let returnVal = null
  if(isInit){
    return {rows: [
        {historyDate: 20250805, revenueAmount : 10, requestCount: 10, responseCount: 10, exposureCount: 10, validClickCount: 10, costAmount: 10}
      ], totalCount: 1}
  }
  await MediaAxios('POST', `/statistics/${userId}/all`, toPeriodRequestParams(params))
    .then(response => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = {totalElements: 0 ,content:[]}
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}
export async function selectUserStaticsHourlyAll(userId, params) {
  let returnVal = null
  await MediaAxios('POST', `/statistics/${userId}/all/hourly`, toPeriodRequestParams(params))
  .then(response => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = {totalElements: 0 ,content:[]}
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}

// 매체 어드민
export async function selectAdminStaticsAll(userId, params) {
  let returnVal = null
  if(isInit){
    return {rows: [
        {historyDate: 20250805, revenueAmount : 10, requestCount: 10, responseCount: 10, exposureCount: 10, validClickCount: 10, costAmount: 10}
      ], totalCount: 1}
  }

  if(userId !== undefined) {
    await AdminAxios('POST', `/media/statistics/${userId}/all`, toPeriodRequestParams(params))
    .then(response => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = {totalElements: 0 ,content:[]}
      }
    }).catch((e) => returnVal = false)
  } else {
    await AdminAxios('POST', `/media/statistics/all`, toPeriodRequestParams(params))
    .then(response => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = {totalElements: 0 ,content:[]}
      }
    }).catch((e) => returnVal = false)

  }

  return returnVal;
}
export async function selectAdminStaticsHourAll(userId, params) {
  let returnVal = null

  if(userId !== undefined) {
    await AdminAxios('POST', `/media/statistics/${userId}/all/hourly`, toPeriodRequestParams(params))
    .then(response => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = {totalElements: 0 ,content:[]}
      }
    }).catch((e) => returnVal = false)
  } else {
    await AdminAxios('POST', `/media/statistics/all/hourly`, toPeriodRequestParams(params))
    .then(response => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = {totalElements: 0 ,content:[]}
      }
    }).catch((e) => returnVal = false)

  }

  return returnVal;
}
